import { useState, useRef, useEffect } from "react";

const DEBUG_TAP_COUNT = 10;
const DEBUG_TAP_TIMEOUT_MS = 1500;

function usePaywallDebug() {
  const [debugOpen, setDebugOpen] = useState(false);
  const tapCountRef = useRef(0);
  const tapTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (tapTimeoutRef.current) clearTimeout(tapTimeoutRef.current);
    };
  }, []);

  const handleTierTap = () => {
    if (debugOpen) return;
    const newCount = tapCountRef.current + 1;
    if (newCount >= DEBUG_TAP_COUNT) {
      setDebugOpen(true);
      tapCountRef.current = 0;
      if (tapTimeoutRef.current) clearTimeout(tapTimeoutRef.current);
    } else {
      tapCountRef.current = newCount;
      if (tapTimeoutRef.current) clearTimeout(tapTimeoutRef.current);
      tapTimeoutRef.current = setTimeout(() => {
        tapCountRef.current = 0;
      }, DEBUG_TAP_TIMEOUT_MS);
    }
  };

  const handleDebugClose = () => {
    setDebugOpen(false);
    tapCountRef.current = 0;
  };

  return { debugOpen, handleTierTap, handleDebugClose };
}

export default usePaywallDebug;
